import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { VerticalStepsType } from '../../types';
import SimpleAccordion from '../SimpleAccordion';

export type VerticalStepsProps = {
  data: VerticalStepsType[];
};

const VerticalSteps = ({ data }: VerticalStepsProps) => {
  return (
    <Container className="vertical-steps-container px-0 mt-12">
      {data.map((prop: any, index: React.Key) => (
        <Row key={index} className="m-0 wrapper d-flex flex-nowrap">
          {/* <Col className="age-container d-flex flex-column mt-2 text-ligther-grey">
            <span className="age-number mb-1">{prop.age}</span>
            <span className="text-sub1 fw-light">Age</span>
          </Col> */}
          <Col className="p-0 col-lg-12 pb-11">
            <div className="content position-relative">
              <SimpleAccordion props={prop} />
            </div>
          </Col>
        </Row>
      ))}
    </Container>
  );
};

export default VerticalSteps;
